import { APIError } from "@bvhi/backend-api/api-error";
import { Card, CardContent, CardHeader, Grid, TextField } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";
import { FormTextFieldUsername } from "../../../../components/common/form-text-field-username";
import { FormTextFieldUsernameConfirmation } from "../../../../components/common/form-text-field-username-confirmation";
import { useAuthContext } from "../../../../context/use-auth-context";

export const UpdateUsernameCard = () => {
  const { currentUser } = useAuthContext();
  if (!currentUser) {
    throw new APIError("CurrentUser does not exist.", {
      status: 401,
      code: "UNAUTHORIZED",
      message: "CurrentUser does not exist.",
      timestamp: new Date().toISOString(),
    });
  }

  const { t } = useTranslation(["users", "profile"]);

  return (
    <Card elevation={0}>
      <CardHeader subheader={t("profile:profile.update.username.card.sub.title")} title={t("profile:profile.update.username.card.title")} />
      <CardContent>
        <Grid container spacing={2}>
          <Grid xs={12}>
            <TextField
              disabled
              fullWidth
              label={t("profile:profile.update.username.card.username.label")}
              sx={{ pb: 3 }}
              value={currentUser.username}
            />
          </Grid>
          <Grid xs={12}>
            <FormTextFieldUsername inputProps={{ autoComplete: "username" }} />
          </Grid>
          <Grid xs={12}>
            <FormTextFieldUsernameConfirmation
              inputProps={{ autoComplete: "username" }}
              onPaste={(e) => {
                e.preventDefault();
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
